import { useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import api from "../../api/api";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const useUploadTrainings = () => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [resp, setResp] = useState(null);
  const { authState, oktaAuth } = useOktaAuth();
  //const { authState } = useOktaAuth();
  const accessToken = authState.accessToken.accessToken;
  const { userEmail, userRole } = useSelector((state) => state.user);

  const uploadFile = async (file) => {
    try {
      setIsUploading(true);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("email", userEmail);
      formData.append("userRole", userRole);
      return await api
        .post("training/upload", formData, {
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
        })
        .then((response) => {
          if (!response.statusText === "OK") {
            toast.error("File upload failed.");
            return;
          }

          setIsUploading(false);
          setUploadError(null);
          return response;
        });
    } catch (error) {
      setIsUploading(false);
      setUploadError(error.message);
    }
  };

  return {
    isUploading,
    uploadError,
    uploadFile,
    resp,
  };
};

export default useUploadTrainings;
